export const Home = '';
export const GetStarted = 'get-started';
export const FullSignatoryPage = 'full-signatory';
export const ThreeStepsToRegisterDelegateAccess = 'three-steps-to-register';
export const ThreeStepsToRegisterApproval = 'three-steps-to-register-approval';
export const ThreeStepsToRegisterDesktop =
  'three-steps-to-register-for-desktop';
export const ThreeStepsToRegisterIdVerify = 'three-steps-to-register-id-verify';
export const Redirect = 'redirect';
export const RegistrationApproval = 'approve-your-registration';
export const TriageDeviceSwitch = 'switch-to-mobile';
export const SwitchToMobileQrScan = 'scan-qr-code';
export const AboutTheBusiness = 'about-the-business';
export const MayfairAccountError = 'mayfair-account';
export const AboutYou = 'about-you';
export const MobileNumberMissing = 'mobile-number-missing';
export const AlreadyRegistered = 'already-registered';
export const TechnicalErrorPage = 'technical-error';
export const RegistrationInProgress = 'registration-in-progress';
export const SmsOtp = 'sms-otp';
export const SmsOtpAuthorize = 'sms-otp/authorise';
export const SessionTimedOut = 'session-timed-out';
export const UnableToVerify = 'unable-to-verify';
export const SubmitYourRegistration = 'submit-your-registration';
export const ThankYou = 'thank-you';
export const IdvWrapper = '/idv/*';
export const IdvHardFailure = 'hard-failure';
export const IdvErrorPage = 'idv-error';
